import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import {STATUS_ADDRESS} from "../../../../../../utility/SourceAPI"

export const getStatusAddress = createAsyncThunk('appStatusAddress/getStatusAddress', async () => {
    const response = await axios.get(STATUS_ADDRESS)
    return response.data
})

export const addStatusAddress = createAsyncThunk('appStatusAddress/addStatusAddress', async (status, {dispatch}) => {
    const response = await axios.post(STATUS_ADDRESS, status)
    await dispatch(getStatusAddress())
    return response.data
})

export const appStatusAddressSlice = createSlice({
        name: 'appStatusAddress',
        initialState: {
            data: []
        },
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(getStatusAddress.fulfilled, (state, action) => {
                state.data = action.payload
            })
        }
    }
)

export default appStatusAddressSlice.reducer